import _ from "lodash";

export default {
  props: {
    item: Object,
    show: Boolean,
  },
  data() {
    return {
      dialog: false,
      cmt_rules: [(v) => v.length <= 60 || "Max 60 caratteri"],
      help_menu: false,
      cmt_to_send: "",
      colori: [],
    };
  },
  created() {
    this.debouncecmt = _.debounce(this.invia_cmt, 1200);
  },
  mounted() {},
  computed: {
    commento: {
      get() {
        let art = this.$store.getters.get_prodotto_carrello(this.item.id);
        return art ? art.commento : "";
      },
      set(cmt) {
        this.cmt_to_send = cmt;
        this.debouncecmt();
      },
    },
    foto_array() {
      let array = [];
      for (let i = 0; i < this.item.img_list_count; i++) {
        array.push(this.item.img_list_src + i);
      }
      return array;
    },

    unita() {
      if (this.item.unita == "1") {
        return "Vaso Singolo";
      } else {
        return "Cassa da " + this.item.unita;
      }
    },
    prezzo_cliente() {
      if (this.item.prezzo) {
        return this.item.prezzo;
      }
      let listino = this.$store.getters.get_carrello.cliente.listino;
      switch (listino) {
        case "1":
          return this.item.prezzo1;
        case "2":
          return this.item.prezzo2;
        case "3":
          return this.item.prezzo3;
      }
    },
    prezzo_unitario() {
      return (this.prezzo_cliente / this.item.unita).toFixed(2);
    },
    nome() {
      if (this.item.nome.includes("Vaso")) {
        return this.item.nome.split("Vaso")[0];
      } else {
        return this.item.nome.split("Basket")[0];
      }
    },
    main_img() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/main_img/" +
        this.item.id +
        "?t=" +
        this.item.img_md5
      );
    },
    avatar_img() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/avatar_img/" +
        this.item.id +
        "?t=" +
        this.item.avatar_md5
      );
    },
    exist() {
      return this.$store.getters.get_prodotto_carrello(this.item.id);
    },
    specie() {
      return this.$store.getters.get_specie_by_id(this.item.specie);
    },
    gruppo_serie() {
      const result = this.colori
        .filter(
          (colore) =>
            this.item.series.includes(colore.id_series[0]) ||
            (this.item.series.includes("000000") &&
              colore.id_series.length == 0)
        )
        .reduce((acc, obj) => {
          // Se l'array id_series è vuoto, aggiungi il prodotto sotto null
          if (obj.id_series.length === 0) {
            if (!acc[null]) {
              acc[null] = [];
            }
            acc[null].push(obj);
          } else {
            // Altrimenti, iteriamo su id_series e aggiungiamo il prodotto ai rispettivi id_series
            obj.id_series.forEach((id_series) => {
              if (!acc[id_series]) {
                acc[id_series] = [];
              }
              acc[id_series].push(obj);
            });
          }
          return acc;
        }, {});

      const finalArray = Object.entries(result).map(([key, value]) => ({
        id_series: key !== "null" ? key : null, // Converti 'null' in vero null
        colori: value,
      }));
      finalArray.sort((a, b) => {
        if (a.id_series === null) return -1;
        if (b.id_series === null) return 1;
        return 0; // Lascia invariato l'ordine per gli altri elementi
      });
      return finalArray;
    },
  },

  watch: {
    $route(to, from) {
      if (from.hash === "#dettaglio-prodotto" && this.dialog) {
        this.dialog = false;
      }
    },
  },

  methods: {
    get_serie(id_serie) {
      return this.specie.series.find((serie) => serie.id == id_serie);
    },
    async fetchAllColors() {
      this.colori = await this.$store.dispatch(
        "fetch_colori_by_id",
        this.specie.colori
      );
    },
    invia_cmt() {
      this.$store.dispatch("invio_commento", {
        id_prodotto: this.item.id,
        commento: this.cmt_to_send,
      });
    },
    open() {
      this.fetchAllColors();
      this.dialog = true;
      this.$router.push("#dettaglio-prodotto");
    },
    close_dial() {
      this.dialog = false;
      this.$router.back();
    },
  },
};
